import { z } from "zod";
import type { ItemsCondition} from "./items-condition";
import { itemsConditionZodSchema } from "./items-condition";
import type {
    MinNumberOfItemsCondition} from "./min-number-of-items-condition";
import {
    minNumberOfItemsConditionType,
    minNumberOfItemsConditionZodSchema,
} from "./min-number-of-items-condition";
import type {
    ProviderCondition} from "./provider-condition";
import {
    providerConditionType,
    providerConditionZodSchema,
} from "./provider-condition";
import type {
    ResourceCondition} from "./resource-condition";
import {
    resourceConditionType,
    resourceConditionZodSchema,
} from "./resource-condition";
import type {
    TimeOfDayCondition} from "./time-of-day-condition";
import {
    timeOfDayConditionType,
    timeOfDayConditionZodSchema,
} from "./time-of-day-condition";
import type {
    TimeRangeCondition} from "./time-range-condition";
import {
    timeRangeConditionType,
    timeRangeConditionZodSchema,
} from "./time-range-condition";
import type {
    ValueCondition} from "./value-condition";
import {
    valueConditionType,
    valueConditionZodSchema,
} from "./value-condition";
import type {
    WeekdayCondition} from "./week-day-condition";
import {
    weekdayConditionType,
    weekdayConditionZodSchema,
} from "./week-day-condition";

type DiscountCondition =
    | MinNumberOfItemsCondition
    | ItemsCondition
    | ProviderCondition
    | TimeRangeCondition
    | ValueCondition
    | WeekdayCondition
    | ResourceCondition
    | TimeOfDayCondition;

const discountConditionZodSchema: z.ZodSchema<DiscountCondition> = z.union([
    minNumberOfItemsConditionZodSchema,
    providerConditionZodSchema,
    itemsConditionZodSchema,
    timeRangeConditionZodSchema,
    valueConditionZodSchema,
    weekdayConditionZodSchema,
    resourceConditionZodSchema,
    timeOfDayConditionZodSchema,
]);
type DiscountConditionType = DiscountCondition["type"];
const discountConditionTypeZodSchema: z.ZodSchema<DiscountConditionType> =
    z.enum([
        minNumberOfItemsConditionType,
        providerConditionType,
        timeRangeConditionType,
        valueConditionType,
        weekdayConditionType,
        resourceConditionType,
        timeOfDayConditionType,
    ]);

export { discountConditionZodSchema, discountConditionTypeZodSchema };
export type { DiscountCondition, DiscountConditionType };
